<template>  
  <div class="modal-window uts023">
        <header class="modal-header">
            <div class="tit">{{modalInfo.title}}</div>
            <button @click="closeModal" class="btn_close">닫기</button>
        </header>
        
        <div class="modal-content">
          <form action="" @submit.prevent="false==false"> 
            <div class="input-box" v-if="modalInfo.name == 'updateFolderName'"> 
              <input type="text" required :placeholder="$i18nUtil.trans('UB006.002')"  v-model="updateCategoryName" @input="displayBytes(maxBytes, updateCategoryName, $event)">
              <button type="button" class="input-txt-del" @click="updateCategoryName = '',error = false ">입력 삭제</button>
              <div class="error" v-if="error">{{ $i18nUtil.trans("message.RegistCategoryModal.005","입력 가능한 글자수를 초과하였습니다.") }} <span>({{checkBytes + `/` + maxBytes + `bytes`}})</span></div>
              <div class="error" v-if="errorFolderName === true" >{{$i18nUtil.trans("UB006")}}</div>
            </div>  
            <div class="input-box" v-if="modalInfo.name == 'registFolder'"> 
              <input type="text" required :placeholder='$i18nUtil.trans("UB006.001")'  v-model="addCategoryName" @input="displayBytes(maxBytes, addCategoryName, $event)" >
              <button type="button" class="input-txt-del" @click="addCategoryName = '',error = false ">입력 삭제</button>
              <div class="error" v-if="error">{{ $i18nUtil.trans("message.RegistCategoryModal.005","입력 가능한 글자수를 초과하였습니다.") }} <span>({{checkBytes + `/` + maxBytes + `bytes`}})</span></div>
              <div class="error" v-if="errorFolderName === true" >{{$i18nUtil.trans("UB006")}}</div>
              <br><br>
              <!-- <dt>대시보드 속성 </dt>
              <dd>
                <input type="radio" id="ideation" value="IDEATION" v-model="section"> <label for="ideation">Ideation</label> 
                <input type="radio" id="execution" value="EXECUTION" v-model="section"> <label for="execution">Execution</label>
              </dd> -->
            </div>
          </form>
        </div>

        <footer class="modal-footer">
            <button type="button" class="btn_ty1" @click="onClickSubmit">{{ $i18nUtil.trans("button.RegistCategoryModal.save","등록") }}</button>
        </footer>
    </div>
</template>

<script>
import { mapActions } from "vuex";
import axios from "axios";

export default {
  props: {
    modalInfo: {
      type: Object,
      required: true,
    },
  },
  components: {
  },
  data() {
    return {
      updateCategoryName: this.modalInfo.category != null ? this.modalInfo.category.category.categoryName : '',
      addCategoryName:'', 
      section:'IDEATION',  

      error: false, 
      checkBytes: 0,
      maxBytes: 80, 
      errorFolderName: null,

      toastInfo: {
        obj: this.$toasted,
        message: "",
        options: {
          theme: "toasted-primary",
          position: "bottom-left",
          duration: 3000,
        },
      },

    };
  },
  mounted() {
     
  },
  watch: {
  },
  beforeDestroy() {
  },
  methods: {
    ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
    ...mapActions("modals", ["showToast"]),
    onClickSubmit() { 
        if(this.modalInfo.name == "updateFolderName"){
            if(this.error){
              this.updateCategoryName= this.cutByteLength(this.updateCategoryName, this.maxBytes);
              return;
            }
            if(this.updateCategoryName == null || this.updateCategoryName == undefined || this.updateCategoryName.length == 0) {
              this.errorFolderName = true;
              return;
            } else {
              this.errorFolderName = false;
            }  

            let category = this.modalInfo.category; 
            category.category.categoryName = this.updateCategoryName;
            this.$emit("update-categoryName",category);
            this.$emit('close'); 

        }else if( this.modalInfo.name=="registFolder"){ 
            if(this.error && this.addCategoryName.length != 0){
              this.addCategoryName = this.cutByteLength(this.addCategoryName, this.maxBytes);
              return;
            }
            if(this.addCategoryName == null || this.addCategoryName == undefined || this.addCategoryName.length == 0) {
              this.error = false;
              this.errorFolderName = true;
              return;
            } else {
              this.errorFolderName = false;
            } 
            let param = {
                categoryId: null,
                categoryName: this.addCategoryName,
                groupId: this.modalInfo.groupId,
                parentCategoryMid: this.modalInfo.parentCategoryMid,
                projectId: this.modalInfo.projectId,
                regUserId: this.modalInfo.regUserId,
                section: this.section,
                sortNo: 1,
                modDate: null,
                modUserId: null,
                delKbn: 0,
                delDate: null,
                delUserId: null
            }; 
            let parentCategory='';
            if(this.section == "IDEATION"){
                parentCategory = "i";
            }else if(this.section == "EXECUTION"){
                parentCategory = "e";
            } 
            this.$emit("add-category", param, parentCategory);
            this.$emit('close'); 
        }    
    },
    /* byte 체크 */
    displayBytes(byteLength, addCategoryName, _event) {
        let obj = this;
        addCategoryName = _event.target.value;
        obj.addCategoryName = addCategoryName;
        let checkBytes = obj.getByteLength(obj.addCategoryName);
        obj.checkBytes = checkBytes;
        obj.error = false;
        if(checkBytes > byteLength) {
          obj.error = true; 
        }
        if(checkBytes > 0) {
          obj.errorFolderName = false;
        } 
    },
    getByteLength(str) {
        if (str == null || str.length == 0) {
            return 0;
        }
        var size = 0;
        for ( var i = 0; i < str.length; i++) {
            size += this.charByteSize(str.charAt(i));
        }
        return size;
    },
    cutByteLength(s, len) {
        if (s == null || s.length == 0) {
            return 0;
        }
        var size = 0;
        var rIndex = s.length;
        for ( var i = 0; i < s.length; i++) {
            size += this.charByteSize(s.charAt(i));
            if( size == len ) {
                rIndex = i + 1;
                break;
            } else if( size > len ) {
                rIndex = i;
                break;
            }
        }
        return s.substring(0, rIndex);
    },
    charByteSize(ch) {
        if (ch == null || ch.length == 0) {
            return 0;
        }
        var charCode = ch.charCodeAt(0);

        if (charCode <= 0x00007F) {
            return 1;
        } else if (charCode <= 0x0007FF) {
            return 2;
        } else if (charCode <= 0x00FFFF) {
            return 2;
        } else {
            return 2;
        }
    },
    closeModal(){
      this.toastInfo.message = this.$i18nUtil.trans("message.RegistCategoryModal.007","취소되었습니다.");
      this.showToast(this.toastInfo);
      this.$emit('close')
    }
  },
};
</script>


// WEBPACK FOOTER //
// src/components/cowork/general/project/modal/RegistCategoryModal.vue